import {getRequiredStyleTitle} from "@/pages/productClass/components/util.tsx";

export const config = {
  rowSelection: false,
  pagination: false,
  fieldControl: false,
  columns: [
    {
      title: 'SPU名称/SPU_ID',
      dataIndex: 'productName',
      width: 200,
      ellipsis: true,
      render: 'nameRender',
    },
    {
      title: '单位',
      dataIndex:  ['unitInfo', 'unitName'],
      width: 100,
      ellipsis: true,
    },
    {
      title: getRequiredStyleTitle('数量'),
      dataIndex: 'size',
      width: 120,
      render: 'numRender',
    },
    {
      title: getRequiredStyleTitle('SKU包含类型'),
      dataIndex: 'selectType',
      width: 160,
      render: 'typeSelectRender'
    },
    {
      title: '操作',
      dataIndex: 'productId',
      fixed: 'right',
      width: 160,
      render: 'actionRender'
    },
  ],
  footer: [
    {
      label: '添加SPU',
      type: 'primary',
      events: ['onClick:onAddSPU']
    }
  ]
}
